export class DesktopNotificationEnvironment {
  public static getName = () => 'benzinga-utils-notification';
  public static getEnvironment = (env: Record<string, string>) => ({
    notificationIcon: env.notificationicon ?? `https://pro.benzinga.com/android-chrome-512x512.png`,
  });
}
